import { render } from "./ipAdd.vue?vue&type=template&id=b5ce3250&scoped=true"
import script from "./ipAdd.vue?vue&type=script&lang=js"
export * from "./ipAdd.vue?vue&type=script&lang=js"

import "./ipAdd.vue?vue&type=style&index=0&id=b5ce3250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ce3250"]])

export default __exports__